import { httpRetry } from '$core/helpers/http-retry';
import { Block } from '$core/models/block';
import { BlogStatic } from '$core/models/static';
import { BlogStaticDto } from '$core/services/static';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Resolve } from '@angular/router';
import { interval, Observable } from 'rxjs';
import { first, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StaticService {
  private readonly http = inject(HttpClient);

  public readonly static = signal<BlogStatic>(<BlogStatic>{});

  public getBlogStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v1/static/blog').pipe(
      httpRetry(5),
      tap((res: BlogStaticDto) =>
        this.static.set(this.transformBlogStaticsDtoToModel(res))
      )
    );
  }

  private transformBlogStaticsDtoToModel(statics: BlogStaticDto): BlogStatic {
    let result = {
      ...statics,
      header: new Block(statics.blocks.header),
      footer: new Block(statics.blocks.footer),
    };
    delete result.blocks;

    return result;
  }
}

@Injectable({
  providedIn: 'root',
})
export class StaticResolver implements Resolve<Observable<any>> {
  constructor(private staticService: StaticService) {}

  public resolve() {
    // Zero interval prevents static double request when navigate on dymamic route
    return interval().pipe(
      first(),
      switchMap(() => this.staticService.getBlogStatics())
    );
  }
}
